import { componentName, ThirdPartyAppLogoClass } from './ThirdPartyAppLogoClass';
import '@descope-ui/descope-icon';
import '../descope-logo';

customElements.define(componentName, ThirdPartyAppLogoClass);

export { ThirdPartyAppLogoClass };
